import n from "react";
import { Label as w, Button as C, Heading as b, Accordion as _, BodyShort as I, Skeleton as $ } from "@navikt/ds-react";
import { BandageIcon as O, DocPencilIcon as x, Chat2Icon as F, EnvelopeClosedIcon as A, TasklistIcon as z, PersonGroupIcon as H, ArrowLeftIcon as B, PersonIcon as R } from "@navikt/aksel-icons";
var o = /* @__PURE__ */ ((e) => (e.Sykmeldinger = "Sykmeldinger", e.Soknader = "S\xF8knader", e.Meldinger = "Beskjeder", e.Dialogmoter = "Dialogm\xF8ter", e.Oppfolgingsplaner = "Oppf\xF8lgingsplaner", e.DineSykmeldte = "Dine Sykmeldte", e))(o || {}), i = /* @__PURE__ */ ((e) => (e.Sykmelding = "Sykmelding", e.Soknad = "S\xF8knad", e.Melding = "Aktivitetsvarsel", e.Dialogmote = "Dialogm\xF8te", e.Oppfolgingsplan = "Oppf\xF8lgingsplan", e))(i || {});
function L(e) {
  return e.endsWith("s") || e.endsWith("x") ? `${e}'` : `${e}s`;
}
function q(e, t) {
  return `${L(e.split(" ")[0])} ${t}`;
}
function D(e) {
  var t, a, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (a = D(e[t])) && (r && (r += " "), r += a);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function c() {
  for (var e, t, a = 0, r = ""; a < arguments.length; )
    (e = arguments[a++]) && (t = D(e)) && (r && (r += " "), r += t);
  return r;
}
function T(e, t) {
  switch (e) {
    case o.DineSykmeldte:
      return !1;
    case o.Sykmeldinger:
      return t === i.Sykmelding;
    case o.Soknader:
      return t === i.Soknad;
    case o.Meldinger:
      return t === i.Melding;
    case o.Dialogmoter:
      return t === i.Dialogmote;
    case o.Oppfolgingsplaner:
      return t === i.Oppfolgingsplan;
  }
}
function y(e) {
  switch (e) {
    case o.DineSykmeldte:
      throw new Error("DineSykmeldte root page has no children");
    case o.Sykmeldinger:
      return i.Sykmelding;
    case o.Soknader:
      return i.Soknad;
    case o.Meldinger:
      return i.Melding;
    case o.Dialogmoter:
      return i.Dialogmote;
    case o.Oppfolgingsplaner:
      return i.Oppfolgingsplan;
  }
}
function j(e, t, a) {
  switch (t) {
    case o.DineSykmeldte:
      return "/arbeidsgiver/sykmeldte";
    case o.Sykmeldinger:
      return `/arbeidsgiver/sykmeldte/sykmeldt/${a}/sykmeldinger`;
    case o.Soknader:
      return `/arbeidsgiver/sykmeldte/sykmeldt/${a}/soknader`;
    case o.Meldinger:
      return `/arbeidsgiver/sykmeldte/sykmeldt/${a}/meldinger`;
    case o.Dialogmoter:
      return k(e) ? `/arbeidsgiver/sykmeldte/dialogmoter/${a}` : `/syk/dialogmoter/arbeidsgiver/${a}`;
    case o.Oppfolgingsplaner:
      return k(e) ? `/arbeidsgiver/sykmeldte/oppfolgingsplaner/${a}` : `/syk/oppfolgingsplaner/arbeidsgiver/${a}`;
  }
}
function N(e) {
  switch (e) {
    case o.DineSykmeldte:
      return H;
    case o.Soknader:
    case i.Soknad:
      return z;
    case o.Meldinger:
    case i.Melding:
      return A;
    case o.Dialogmoter:
    case i.Dialogmote:
      return F;
    case o.Oppfolgingsplaner:
    case i.Oppfolgingsplan:
      return x;
    case o.Sykmeldinger:
    case i.Sykmelding:
      return O;
  }
}
function k(e) {
  switch (e) {
    case o.Sykmeldinger:
    case i.Sykmelding:
    case o.Soknader:
    case i.Soknad:
    case o.Meldinger:
    case i.Melding:
    case o.DineSykmeldte:
      return !0;
    case o.Dialogmoter:
    case o.Oppfolgingsplaner:
    case i.Dialogmote:
    case i.Oppfolgingsplan:
      return !1;
  }
}
const W = "_notifcationDot_1qo1z_1", G = "_absolute_1qo1z_16", S = {
  notifcationDot: W,
  absolute: G
};
function U({ notifications: e, tooltip: t, absolute: a }) {
  return /* @__PURE__ */ n.createElement("div", {
    className: c(S.notifcationDot, { [S.absolute]: a }),
    title: t
  }, e);
}
function v({ Icon: e, childActive: t, notifications: a }) {
  return t ? /* @__PURE__ */ n.createElement(B, {
    role: "img",
    "aria-hidden": !0
  }) : a > 0 ? /* @__PURE__ */ n.createElement(U, {
    notifications: a
  }) : /* @__PURE__ */ n.createElement(e, {
    role: "img",
    "aria-hidden": !0
  });
}
const J = "_menuItem_1lrfp_1", K = "_notifyingItem_1lrfp_1", Q = "_activeItem_1lrfp_5", V = "_menuItemButton_1lrfp_9", l = {
  menuItem: J,
  notifyingItem: K,
  activeItem: Q,
  menuItemButton: V
}, X = "_subMenuItem_w5ck1_1", Y = "_activeSubItem_w5ck1_1", h = {
  subMenuItem: X,
  activeSubItem: Y
};
function M({ page: e }) {
  const t = N(e);
  return /* @__PURE__ */ n.createElement("li", {
    className: h.subMenuItem
  }, /* @__PURE__ */ n.createElement("div", {
    className: c("navds-button--small", h.activeSubItem)
  }, /* @__PURE__ */ n.createElement(t, {
    role: "img",
    "aria-hidden": !0
  }), /* @__PURE__ */ n.createElement(w, {
    size: "small"
  }, e)));
}
function d({ sykmeldtId: e, page: t, activePage: a, route: r }) {
  if (typeof r == "boolean" || typeof r != "number" && r.hide)
    return null;
  const p = N(t), m = T(t, a);
  if (typeof r == "number") {
    const E = r;
    return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("li", {
      className: l.menuItem
    }, /* @__PURE__ */ n.createElement(C, {
      className: c(l.menuItemButton, {
        [l.activeItem]: a === t,
        [l.notifyingItem]: E > 0
      }),
      href: j(a, t, e),
      as: "a",
      variant: "tertiary",
      size: "small",
      icon: /* @__PURE__ */ n.createElement(v, {
        Icon: p,
        childActive: m,
        notifications: E
      })
    }, t)), m && /* @__PURE__ */ n.createElement(M, {
      page: y(t)
    }));
  }
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("li", {
    className: l.menuItem
  }, /* @__PURE__ */ n.createElement(r.internalRoute, {
    className: c(
      "navds-button navds-button--tertiary navds-button--small",
      l.menuItemButton,
      {
        [l.activeItem]: a === t,
        [l.notifyingItem]: r.notifications > 0
      }
    )
  }, /* @__PURE__ */ n.createElement("span", {
    className: "navds-button__icon"
  }, /* @__PURE__ */ n.createElement(v, {
    Icon: p,
    childActive: m,
    notifications: r.notifications
  })), /* @__PURE__ */ n.createElement("span", {
    className: "navds-label navds-label--small"
  }, t))), m && /* @__PURE__ */ n.createElement(M, {
    page: y(t)
  }));
}
const Z = "_navRoot_1euqs_1", P = "_heading_1euqs_5", ee = "_buttonList_1euqs_11", f = {
  navRoot: Z,
  heading: P,
  buttonList: ee
};
function Me({ sykmeldtName: e, sykmeldtId: t, activePage: a, routes: r }) {
  return /* @__PURE__ */ n.createElement("nav", {
    "aria-labelledby": "side-menu-header",
    className: f.navRoot
  }, /* @__PURE__ */ n.createElement(b, {
    id: "side-menu-header",
    size: "small",
    className: f.heading
  }, q(e, "oversikt")), /* @__PURE__ */ n.createElement("ul", {
    className: f.buttonList
  }, /* @__PURE__ */ n.createElement(d, {
    sykmeldtId: t,
    page: o.Sykmeldinger,
    route: r.Sykmeldinger,
    activePage: a
  }), /* @__PURE__ */ n.createElement(d, {
    sykmeldtId: t,
    page: o.Soknader,
    route: r.Soknader,
    activePage: a
  }), /* @__PURE__ */ n.createElement(d, {
    sykmeldtId: t,
    page: o.Dialogmoter,
    route: r.Dialogmoter,
    activePage: a
  }), /* @__PURE__ */ n.createElement(d, {
    sykmeldtId: t,
    page: o.Oppfolgingsplaner,
    route: r.Oppfolgingsplaner,
    activePage: a
  }), /* @__PURE__ */ n.createElement(d, {
    sykmeldtId: t,
    page: o.Meldinger,
    route: r.Meldinger,
    activePage: a
  }), /* @__PURE__ */ n.createElement(d, {
    sykmeldtId: t,
    page: o.DineSykmeldte,
    route: r.DineSykmeldte,
    activePage: a
  })));
}
function ne(e) {
  return e.replace(/(.{6})/g, "$1 ");
}
const te = "_accordionMobileRoot_iczrb_1", re = "_accordionHeaderContent_iczrb_5", ae = "_peopleIcon_iczrb_11", oe = "_accordionContent_iczrb_18", ie = "_heading_iczrb_22", g = {
  accordionMobileRoot: te,
  accordionHeaderContent: re,
  peopleIcon: ae,
  accordionContent: oe,
  heading: ie
}, le = ({
  sykmeldtNavn: e,
  sykmeldtFnr: t,
  children: a,
  className: r
}) => /* @__PURE__ */ n.createElement(_, {
  className: c(g.accordionMobileRoot, r)
}, /* @__PURE__ */ n.createElement(_.Item, null, /* @__PURE__ */ n.createElement(_.Header, {
  id: `sykmeldt-accordion-header-${t}`
}, /* @__PURE__ */ n.createElement("div", {
  className: g.accordionHeaderContent
}, /* @__PURE__ */ n.createElement(R, {
  className: g.peopleIcon
}), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(b, {
  className: g.heading,
  size: "xlarge",
  level: "3"
}, e), /* @__PURE__ */ n.createElement(I, null, ne(t))))), /* @__PURE__ */ n.createElement(_.Content, {
  className: g.accordionContent
}, a))), ce = "_rootContainer_1grw3_1", se = "_content_1grw3_9", me = "_pageContainer_1grw3_29", de = "_desktopMenuContainer_1grw3_36", ue = "_sideMenuFiller_1grw3_37", ge = "_mobileMenuAccordion_1grw3_42", s = {
  rootContainer: ce,
  content: se,
  pageContainer: me,
  desktopMenuContainer: de,
  sideMenuFiller: ue,
  mobileMenuAccordion: ge
}, pe = "_headerRoot_fv5wd_1", _e = "_wrapper_fv5wd_9", fe = "_heading_fv5wd_19", be = "_subtitle_fv5wd_34", Ee = "_headerExtra_fv5wd_38", ye = "_hideHeaderOnMobile_fv5wd_49", u = {
  headerRoot: pe,
  wrapper: _e,
  heading: fe,
  subtitle: be,
  headerExtra: Ee,
  hideHeaderOnMobile: ye
};
function ke({ header: e, headerRight: t, hideHeaderOnMobile: a, children: r }) {
  return /* @__PURE__ */ n.createElement(n.Fragment, null, typeof e == "object" && /* @__PURE__ */ n.createElement("div", {
    className: c("dinesykmeldte-sidemeny__header", u.headerRoot, {
      [u.hideHeaderOnMobile]: a
    })
  }, /* @__PURE__ */ n.createElement("section", {
    className: c(u.wrapper),
    "aria-labelledby": "page-header"
  }, /* @__PURE__ */ n.createElement("div", {
    className: u.heading
  }, e.Icon && /* @__PURE__ */ n.createElement(e.Icon, {
    role: "img",
    "aria-hidden": !0
  }), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(b, {
    id: "page-header",
    level: "1",
    size: "xlarge"
  }, e.title), e.subtitle && /* @__PURE__ */ n.createElement(I, {
    className: u.subtitle
  }, e.subtitle), !e.subtitle && e.subtitleSkeleton && /* @__PURE__ */ n.createElement($, {
    variant: "text",
    width: "100%",
    height: "var(--a-font-size-heading-xlarge)"
  }))), t && /* @__PURE__ */ n.createElement("div", {
    className: u.headerExtra
  }, t))), r);
}
const Ie = ({
  header: e,
  headerRight: t,
  sykmeldt: a,
  navigation: r,
  children: p,
  className: m
}) => /* @__PURE__ */ n.createElement(ke, {
  header: e,
  headerRight: t,
  hideHeaderOnMobile: !!r
}, r && a ? /* @__PURE__ */ n.createElement(le, {
  sykmeldtNavn: a.navn,
  sykmeldtFnr: a.fnr,
  className: s.mobileMenuAccordion
}, r) : null, /* @__PURE__ */ n.createElement("div", {
  className: c(s.rootContainer, m)
}, /* @__PURE__ */ n.createElement("div", {
  className: s.content
}, r ? /* @__PURE__ */ n.createElement("div", {
  className: s.desktopMenuContainer
}, r) : /* @__PURE__ */ n.createElement("div", {
  className: s.sideMenuFiller
}), /* @__PURE__ */ n.createElement("section", {
  className: s.pageContainer
}, p), /* @__PURE__ */ n.createElement("div", {
  className: s.sideMenuFiller
}))));
export {
  i as ChildPages,
  U as NotifcationDot,
  Ie as PageContainer,
  o as RootPages,
  Me as SideMenu
};
